const AncillariesLoaderBase = require('./loader.base');
const Fetcher = require('od-modules/utils/fetcher');

const URL_MAPPING = {
    getBags: 'ancillaries',
    getSeats: 'ancillaries',
    getSeatsCheckIn: 'ancillaries',
};

const formatQueryParams = (params = {}) => Object.entries(params).map(([key, value]) => `${key}=${value}`);

const formatQueryString = (params = {}) => `/?${formatQueryParams(params).join('&')}`;

const formatUrl = (url) => Odigeo.Settings.getProperty('serviceUsersFormatter')(url);

const getUrlMapping = (action) => formatUrl(URL_MAPPING[action] || '');

const getUrl = ({queryParams = {}, action} = {}) => getUrlMapping(action) + formatQueryString(queryParams);

const getMail = ({buyer = {}} = {}) => buyer.mail;

const getBookingId = ({bookingBasicInfo = {}} = {}) => bookingBasicInfo.id;

const formatQueryData = ({bookingInfo = {}, service, action} = {}) => ({
    queryParams: {
        email: getMail(bookingInfo),
        bookingid: getBookingId(bookingInfo),
        service,
    },
    action,
});

class BasicAncillariesLoader extends AncillariesLoaderBase {
    timerId = undefined;
    load(bookingInfo, options) {
        this.fetchData(formatQueryData({
            bookingInfo,
            service: this.service,
            action: this.action,
        }), options).then(this.onDataReceived.bind(this))
            .catch(this.onError.bind(this));
    }

    _fetchData(params = {}, options = {}) {
        return Fetcher.get(getUrl(params), options).json();
    }

    fetchData(params = {}, options = {}) {
        if (!options.timeout || !options.timeoutCallback) {
            return this._fetchData(params, options);
        }

        const {timeout = 30000} = options;

        const controller = new AbortController();

        function executeTimeout() {
            controller.abort();
            options.timeoutCallback();
        }

        this.timerId = setTimeout(() => {
            executeTimeout();
        }, timeout);

        return this._fetchData(params, {signal: controller.signal})
            .then((data) => {
                clearTimeout(this.timerId);
                return data;
            })
            .catch((data) => {
                clearTimeout(this.timerId);
                return data;
            });
    }
}

module.exports = BasicAncillariesLoader;
